import React from "react";

const CompanyNotFound: React.FC = () => {
  return (
    <div className="company-not-found">
      <div className="not-found-code">404</div>
      <div className="not-found-message">Company not found</div>
      <div className="not-found-description">
        This company page doesn't exist or is no longer public.
      </div>
    </div>
  );
};

export default CompanyNotFound;
